'use strict';

import Cookies from 'js-cookie';

export default class Alert {
    constructor() {
        const $alertCloseButton = $('.alert__close');
        const $alertBox = $('#block-ric-globalalert');

        // Checks if the alert has already been viewed in the current session
        if (Cookies.get('alertBox') !== 'viewed' && $alertBox.length) {
            $alertBox.show(); 
            $('body').addClass('alertBox');
        } else {
            $alertBox.hide();
        }

        // Adds the click event on the alert close button
        if ($alertCloseButton.length) {
            $alertCloseButton.on('click', function () {
                Cookies.set('alertBox', 'viewed');
                $('body').removeClass('alertBox');
                $alertBox.hide();
            });
        }
    }
}
